import { Table, Tag, Box, Text } from '@nimbus-ds/components';
import { InvoicesTaxRulesResponseDto } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import StatesPopover from './StatesPopover';
import { getStateName } from '../utils';

interface TaxRulesTableBodyProps {
  taxRules: InvoicesTaxRulesResponseDto[];
}
function TaxRulesTableBody({ taxRules }: Readonly<TaxRulesTableBodyProps>) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  const statesName = (state: string) => getStateName(state);

  const countStates = (states: string[]) =>
    t('countStates', { count: states.length });

  return (
    <Table.Body>
      {taxRules.map(({ description, states, id }) => {
        const isShowTag = states.length <= 1;
        const showTag = () => {
          if (states.length === 0) {
            return <Tag>{t('allStates')}</Tag>;
          } else if (states.length === 1) {
            return <Tag>{getStateName(states[0])}</Tag>;
          }
        };
        return (
          <Table.Row key={id}>
            <Table.Cell>
              <Text fontWeight="medium">{description}</Text>
            </Table.Cell>
            <Table.Cell>
              {isShowTag ? (
                showTag()
              ) : (
                <Box display="flex" flexDirection="row" gridGap="2">
                  <Text>{countStates(states)}</Text>
                  <StatesPopover states={states} statesName={statesName} />
                </Box>
              )}
            </Table.Cell>
          </Table.Row>
        );
      })}
    </Table.Body>
  );
}
export default TaxRulesTableBody;
